import { getTemperamentLabel, getTypeLabel } from '@cobasi/cobasi-utils/helpers/pet'
import { PET_GENDERS } from '../../../../utils/constants'
import moment from 'moment'

export const getFormattedFields = (data, isAppointment) => {
  const age = moment().diff(data?.birth, 'years', false)
  const formattedBirthdate = moment(data?.birth).format('DD/MM/yyyy')
  return {
    ...data,
    name: isAppointment ? data?.name : 'Dados do pet',
    subtitle: isAppointment ? 'Confira os dados' : 'Confira os detalhes',
    sex: PET_GENDERS[data?.gender],
    type: data?.breed?.type ? getTypeLabel(data.breed.type) : 'Não informado',
    breed: data?.breed?.name || 'Não informado',
    ...(data?.weight && { weight: `${data?.weight} kg(s)` }),
    ...(data?.birth && { age: age ? `${age} ${age > 1 ? 'anos' : 'ano'}` : 'Menos de 1 ano' }),
    ...(data?.birth && { birthdate: formattedBirthdate }),
    castrated: data?.castrated ? 'Castrado' : 'Não castrado',
    temperament: data?.temperament ? getTemperamentLabel(data?.temperament) : 'Não informado'
  }
}
